import { BaseModel } from '@core/base/base-model';
import { Beneficiary } from '@shared/beneficiary/beneficiary';
import { Enum } from '@shared/enum/enum';
import { QuestionnaireForm } from '@shared/questionnaire-form/questionnaire-form';

export class Survey extends BaseModel {
  name!: string;
  startDate?: Date;
  endDate?: Date;
  externalCode?: string;
  round?: string;
  comment?: string;

  beneficiary?: Beneficiary;
  surveyStatus!: Enum;
  questionnaireForm?: QuestionnaireForm;
}
